var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initialized)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCurrent),expression:"isCurrent"}],staticClass:"route-isolate"},[(!_vm.onRefresh)?_c(_vm.pageComponent,_vm._b({tag:"component"},'component',_vm.pageParams,false)):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }